import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-message-alert',
  imports: [
    TranslatePipe
  ],
  templateUrl: './message-alert.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './message-alert.component.scss'
})
export class MessageAlertComponent {
  show: boolean = true;

  constructor(private router: Router){}

  close(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    this.show = false;

    let originalState = JSON.parse(localStorage.getItem('originalState') || '{"psychologist_connection": true, "notifications": true}');
    originalState.psychologist_connection = false;
    localStorage.setItem('originalState', JSON.stringify(originalState));
  }

  goTo(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    this.router.navigate(['/associate-to-psychologist']);
  }

}
